import {
  checkAdmin,
  checkSignedIn,
  getConcertsSignedUpFor,
} from "../util/firebase";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "../util/Navbar";
import Footer from "../util/Footer";
import homePageImage from "../images/home-page-image.webp";

const HomePage = () => {
  const [signedIn, setSignedIn] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [concerts, setConcerts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getData() {
      const admin = await checkAdmin();
      setAdmin(admin);

      setTimeout(() => {
        checkSignedIn().then((status) => {
          console.log(status);
          setSignedIn(status);
        });
      }, 500);
      //console.log(signedIn);
      window.instgrm.Embeds.process();
    }

    getData();
  }, []);

  useEffect(() => {
    async function getData() {
      if (signedIn && !admin) {
        setIsLoading(true);
        const data = await getConcertsSignedUpFor();
        const date = new Date();
        setConcerts(
          data.filter((concert) => new Date(concert.getConcertDate()) > date)
        );
        setIsLoading(false);
        window.instgrm.Embeds.process();
      }
    }

    getData();
  }, [signedIn, admin]);

  function getDateTime(concert) {
    const dt = new Date(concert.getConcertIsoString());
    const datetime = dt.toLocaleString("en-US", {
      timeZone: concert.getConcertTimezoneLocale(),
    });
    return (
      datetime.substring(0, datetime.length - 6) +
      datetime.substring(datetime.length - 2)
    );
  }

  return (
    <div className="page-content">
      <Navbar />

      {!admin && !signedIn && (
        <div className="landing-page-content">
          <div className="left-content">
            <h1>Join Our Community</h1>
            <p>
              Art of the Heart works on bringing the joy and comfort of music to
              senior citizens, those who are developmentally disabled, isolated
              pediatric patients & low-income adults, and provides young
              musicians with a space to showcase their skills in the form of
              community outreach.
            </p>
            <br />

            <Link to={"../sign_up"} id="sign-up-link" className="button-link">
              Sign Up
            </Link>
          </div>

          <div className="right-content">
            <img
              src={homePageImage}
              alt="student sitting next to an older man"
              id="home-page-image"
            />
          </div>

          <div className="bottom-left-content">
            <blockquote
              className="instagram-media"
              data-instgrm-permalink="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
              data-instgrm-version="14"
              id = "insta-1"
            >
              <div id="insta-2">
                {" "}
                <a
                  href="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
                  target="_blank"
                  id = "insta-3"
                >
                  {" "}
                  <div id="insta-4">
                    {" "}
                    <div id="insta-5"></div>{" "}
                    <div id="insta-6">
                      {" "}
                      <div id="insta-7"></div>{" "}
                      <div id="insta-8"></div>
                    </div>
                  </div>
                  <div id="insta-9"></div>{" "}
                  <div id="insta-10">
                    <svg
                      width="50px"
                      height="50px"
                      viewBox="0 0 60 60"
                      version="1.1"
                      xmlns="https://www.w3.org/2000/svg"
                      xmlnsXlink="https://www.w3.org/1999/xlink"
                    >
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          transform="translate(-511.000000, -20.000000)"
                          fill="#000000"
                        >
                          <g>
                            <path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div id="insta-11">
                    {" "}
                    <div id="insta-12">
                      View this profile on Instagram
                    </div>
                  </div>
                  <div id="insta-13"></div>{" "}
                  <div id="insta-14">
                    <div>
                      {" "}
                      <div id="insta-15"></div>{" "}
                      <div id="insta-16"></div>{" "}
                      <div id="insta-17"></div>
                    </div>
                    <div id="insta-18">
                      {" "}
                      <div id="insta-19"></div>{" "}
                      <div id="insta-20"></div>
                    </div>
                    <div id="insta-21">
                      {" "}
                      <div id="insta-22"></div>{" "}
                      <div id="insta-23"></div>{" "}
                      <div id="insta-24"></div>
                    </div>
                  </div>{" "}
                  <div id="insta-25">
                    {" "}
                    <div id="insta-26"></div>{" "}
                    <div id="insta-27"></div>
                  </div>
                </a>
                <p id="insta-28">
                  <a
                    href="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
                    id="insta-29"
                    target="_blank"
                  >
                    Art of the Heart
                  </a>{" "}
                  (@
                  <a
                    href="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
                    id="insta-30"
                    target="_blank"
                  >
                    artoftheheartmusic
                  </a>
                  ) • Instagram photos and videos
                </p>
              </div>
            </blockquote>{" "}
            
          </div>

          <div className="bottom-right-content">
            <h2>Quick Links</h2>
            <a href="https://www.artoftheheartmusic.org/home">Our Website</a> <br/>
            <a href="https://www.artoftheheartmusic.org/mailing-list">Join Our Mailing List</a> <br/>
            <a href="https://www.artoftheheartmusic.org/contact">Contact Us</a> <br/>
            <a href="https://www.artoftheheartmusic.org/volunteer/area-representative">Become an Area Rep</a><br/>
            <a href="https://www.artoftheheartmusic.org/donate">Donate</a>
          </div>
        </div>
      )}

      {signedIn && !admin && (
        <div className="landing-page-content">
            <div className="left-content">
            <h2>Your Upcoming Concerts</h2>

            {concerts.length !== 0 &&
                !isLoading &&
                concerts.map((concert, i) => (
                <div key={i}>
                    <h3>{concert.getFacilityName()}</h3>
                    <p>
                    {getDateTime(concert)} {concert.getConcertTimezone()}
                    </p>
                    <p>
                    {concert.getCity()}, {concert.getState()}{" "}
                    {concert.getZipCode()}
                    </p>
                    <Link to={`/concerts/${concert.getId()}`}>More Details</Link>
                </div>
                ))}

            {concerts.length === 0 && !isLoading && !admin && (
                <p>You are not signed up for any upcoming concerts.</p>
            )}

            {isLoading && !admin && <p>Loading...</p>}

            <br />
            <br />

            <Link to={"../concerts"} id="concert-link" className="button-link">
                View All Upcoming Concerts
            </Link> <br/><br/><br/>

            <a href="https://www.artoftheheartmusic.org/volunteer/area-representative" className="button-link">
                Become an Area Rep!
            </a>
            </div>

            <div className="right-content">
            <blockquote
              className="instagram-media"
              data-instgrm-permalink="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
              data-instgrm-version="14"
              id = "insta-1"
            >
              <div id="insta-2">
                {" "}
                <a
                  href="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
                  target="_blank"
                  id = "insta-3"
                >
                  {" "}
                  <div id="insta-4">
                    {" "}
                    <div id="insta-5"></div>{" "}
                    <div id="insta-6">
                      {" "}
                      <div id="insta-7"></div>{" "}
                      <div id="insta-8"></div>
                    </div>
                  </div>
                  <div id="insta-9"></div>{" "}
                  <div id="insta-10">
                    <svg
                      width="50px"
                      height="50px"
                      viewBox="0 0 60 60"
                      version="1.1"
                      xmlns="https://www.w3.org/2000/svg"
                      xmlnsXlink="https://www.w3.org/1999/xlink"
                    >
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          transform="translate(-511.000000, -20.000000)"
                          fill="#000000"
                        >
                          <g>
                            <path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div id="insta-11">
                    {" "}
                    <div id="insta-12">
                      View this profile on Instagram
                    </div>
                  </div>
                  <div id="insta-13"></div>{" "}
                  <div id="insta-14">
                    <div>
                      {" "}
                      <div id="insta-15"></div>{" "}
                      <div id="insta-16"></div>{" "}
                      <div id="insta-17"></div>
                    </div>
                    <div id="insta-18">
                      {" "}
                      <div id="insta-19"></div>{" "}
                      <div id="insta-20"></div>
                    </div>
                    <div id="insta-21">
                      {" "}
                      <div id="insta-22"></div>{" "}
                      <div id="insta-23"></div>{" "}
                      <div id="insta-24"></div>
                    </div>
                  </div>{" "}
                  <div id="insta-25">
                    {" "}
                    <div id="insta-26"></div>{" "}
                    <div id="insta-27"></div>
                  </div>
                </a>
                <p id="insta-28">
                  <a
                    href="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
                    id="insta-29"
                    target="_blank"
                  >
                    Art of the Heart
                  </a>{" "}
                  (@
                  <a
                    href="https://www.instagram.com/artoftheheartmusic/?utm_source=ig_embed&amp;utm_campaign=loading"
                    id="insta-30"
                    target="_blank"
                  >
                    artoftheheartmusic
                  </a>
                  ) • Instagram photos and videos
                </p>
              </div>
            </blockquote>{" "}
            </div>
        </div>
      )}

      {admin && (
        <div className="admin-links">
          <Link to={"../admin/student_information"}>Student Information</Link>
          <br />
          <Link to={"../admin/new_concert"}>New Concert</Link>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default HomePage;
